import { useStyles } from "./RightContainerStyle";
import Typography from "@mui/material/Typography";
import SignInImage from "../icons/sing-in-image.png";
import ActiveElpse from "../icons/welcomeActiveelipse.png";
import InactiveElpse from "../icons/welcomeInactiveElipse.png";
import randomquotes from "../random_quotes.json";
import { useEffect, useState } from "react";

interface Props {
  textPlaceholder?: string;
}

export const RightContainer = (props: Props) => {
  const [quote, setQuote] = useState("");

  useEffect(() => {
    const randomQuoteIndex = Math.floor(Math.random() * randomquotes.length);
    setQuote(props.textPlaceholder || randomquotes[randomQuoteIndex].quote);
  }, []);

  const classes = useStyles();
  return (
    <div className={classes.rightContainer}>
      <div style={{ marginBottom: "30px" }}>
        <img src={SignInImage} alt="sing in" />
      </div>
      <div style={{ marginBottom: "30px" }}>
        <Typography
          style={{
            color: "#FFFFFF",
            fontSize: "18px",
            lineHeight: "22px",
            textAlign: "center",
          }}
        >
          {" "}
          {quote}
        </Typography>
      </div>
      <div>
        <img src={ActiveElpse} alt="active" />
        <img src={InactiveElpse} alt="Inactive" />
        <img src={InactiveElpse} alt="Inactive" />
        <img src={InactiveElpse} alt="Inactive" />
      </div>
    </div>
  );
};
